import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgTwitterIcon from './svgs/TwitterIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var twitterIcon = (props => useIcon(SvgTwitterIcon, SvgTwitterIcon, props));

export { twitterIcon as default };
